export const getDateStringByTimestamp = (timestamp) => {
  // Якщо timestamp задано в секундах, перетворюємо його на мілісекунди
    if (timestamp?.toString().length === 10) {
        timestamp *= 1000;
    }

    const date = new Date(timestamp);

    // Форматування дати
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Місяці від 0 до 11
    const day = String(date.getDate()).padStart(2, '0');

    return `${day}.${month}.${year}`;
}

export const getDateStringByTimestampWithTime = (timestamp) => {
    // Якщо timestamp задано в секундах, перетворюємо його на мілісекунди
    if (timestamp.toString().length === 10) {
        timestamp *= 1000;
    }

    const date = new Date(timestamp);

    // Форматування дати
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Місяці від 0 до 11
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
}

export const getMounthNameByNumber = (number) => {
    const mounths = [
        'січень',
        'лютий',
        'березень',
        'квітень',
        'травень',
        'червень',
        'липень',
        'серпень',
        'вересень',
        'жовтень',
        'листопад',
        'грудень'
    ];
    return mounths[number];
}
